import { PageHeader } from '@/components/layout/page-header';
import { AbusePanel } from '@/features/abuse/abuse-panel';
import { SubjectSearch } from '@/features/abuse/subject-search';

const AbuseMonitoringPage = () => (
  <div className="flex flex-col gap-4">
    <PageHeader actions={<SubjectSearch />} description="API abuse scoring across fast-api and fast-funds" title="Abuse Monitoring" />
    <AbusePanel />
  </div>
);
AbuseMonitoringPage.displayName = 'AbuseMonitoringPage';

export default AbuseMonitoringPage;
